import { render, staticRenderFns } from "./WaitingForPos.vue?vue&type=template&id=78f9e978&scoped=true"
import script from "./WaitingForPos.vue?vue&type=script&lang=js"
export * from "./WaitingForPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f9e978",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78f9e978')) {
      api.createRecord('78f9e978', component.options)
    } else {
      api.reload('78f9e978', component.options)
    }
    module.hot.accept("./WaitingForPos.vue?vue&type=template&id=78f9e978&scoped=true", function () {
      api.rerender('78f9e978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WaitingForPos.vue"
export default component.exports